var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_11454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.98978 0.0917969C2.38306 0.0917969 1.80119 0.332814 1.37218 0.761828C0.943166 1.19084 0.702148 1.77271 0.702148 2.37943L0.702148 16.1052C0.702148 16.7119 0.943166 17.2938 1.37218 17.7228C1.80119 18.1518 2.38306 18.3928 2.98978 18.3928H16.7156C17.3223 18.3928 17.9041 18.1518 18.3332 17.7228C18.7622 17.2938 19.0032 16.7119 19.0032 16.1052V2.37943C19.0032 1.77271 18.7622 1.19084 18.3332 0.761828C17.9041 0.332814 17.3223 0.0917969 16.7156 0.0917969L2.98978 0.0917969Z",
    fill: "#15203D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.03732,
    y1: 9.00101,
    x2: 13.6014,
    y2: 9.00101,
    stroke: "white",
    strokeWidth: 1.39055,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_11454"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.702148,
    y: 0.0917969,
    width: 18.301,
    height: 18.301,
    rx: 9.15052,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinus);
export default __webpack_public_path__ + "static/media/icon-minus.4d302df83e7c4d5e663c13c3b0306833.svg";
export { ForwardRef as ReactComponent };